import { createUserRules } from "../helpers";
import { TAF_CAN_PERMISSION_MAPPING } from "./permissions";

export const TAFUserRules = createUserRules(TAF_CAN_PERMISSION_MAPPING);
